import { createContext } from "react";

const defaultValue = {} as any;
const cryptoCurrencyContext = createContext(defaultValue);
export default cryptoCurrencyContext;
